var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmalLogoIco(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.5 40c0 20.71-16.79 37.5-37.5 37.5S2.5 60.71 2.5 40 19.29 2.5 40 2.5 77.5 19.29 77.5 40Zm2.5 0c0 22.091-17.909 40-40 40S0 62.091 0 40 17.909 0 40 0s40 17.909 40 40ZM40.002 25s2.651.918 4.231 1.961c2.22 1.466 3.402 3.126 3.402 5.408V55H32.369V32.369c0-2.282 1.182-3.942 3.402-5.408C37.35 25.918 40 25 40 25Zm-9.43 30h-12.57V35.864c0-2.304.973-3.98 2.8-5.46 1.302-1.054 3.485-1.982 3.485-1.982s2.183.928 3.484 1.981c1.828 1.48 2.801 3.157 2.801 5.461V55Zm25.144 0H62V35.866c0-2.305-.973-3.98-2.801-5.46-1.301-1.054-3.484-1.982-3.484-1.982s-2.184.928-3.485 1.981c-1.828 1.48-2.8 3.156-2.8 5.461V55h6.285Z",
    fill: "#FBF4EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmalLogoIco);
export default __webpack_public_path__ + "static/media/smal-logo_ico.c6e91630914762e879bc62794e744b87.svg";
export { ForwardRef as ReactComponent };